// extracted by mini-css-extract-plugin
module.exports = {"DotMarker":"DotMarker_DotMarker__2hNVA","Label":"DotMarker_Label__vj5aJ"};